/** The same sound never starts twice within this long (a catch-up burst plays it once). */
export const SAME_SOUND_GAP_MS = 50
/** At most `MAX_VOICES` sounds start in any `VOICE_WINDOW_MS`; the rest are dropped. */
export const VOICE_WINDOW_MS = 250
export const MAX_VOICES = 6

/**
 * Keeps bursts readable (PHASE3 T3.6): after a stall the race loop runs several ticks in one
 * frame and the server's queued events arrive together, which would machine-gun sounds. Pure:
 * the caller passes the clock.
 */
export class VoiceLimiter {
  private readonly last = new Map<string, number>()
  private recent: number[] = []

  /** May sound `id` start at `nowMs`? Records it when it may. */
  allow(id: string, nowMs: number): boolean {
    const prev = this.last.get(id)
    if (prev !== undefined && nowMs - prev < SAME_SOUND_GAP_MS) return false
    this.recent = this.recent.filter((t) => nowMs - t < VOICE_WINDOW_MS)
    if (this.recent.length >= MAX_VOICES) return false
    this.recent.push(nowMs)
    this.last.set(id, nowMs)
    return true
  }
}
